import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDownload = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "28px",
	height: "28px",
	viewBox: "0 0 28 28",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Abgeschlossene-Bewertungen",
			transform: "translate(-794.000000, -225.000000)",
			fill: "#F8B477",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-4",
				transform: "translate(138.000000, 213.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "download",
					transform: "translate(656.000000, 12.000000)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M12.9625566,21.5797356 C13.2376987,21.8488256 13.6108802,22 14,22 C14.3891198,22 14.7623013,21.8488256 15.0374434,21.5797356 L20.5702918,16.1688696 C21.1432361,15.6085528 21.1432361,14.7001042 20.5702918,14.1397874 C19.9973432,13.5794748 19.0684146,13.5794748 18.495466,14.1397874 L15.4671288,17.1013591 L15.4671288,1.4347831 C15.4671288,0.642374274 14.8102729,0 14,0 C13.1897271,0 12.5328712,0.642374274 12.5328712,1.4347831 L12.5328712,17.1013591 L9.504534,14.1397874 C8.93158544,13.5794748 8.00265679,13.5794748 7.42970824,14.1397874 C6.85676392,14.7001042 6.85676392,15.6085528 7.42970824,16.1688696 L12.9625566,21.5797356 Z",
						id: "Path"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M26.5517241,13 C25.7518635,13 25.1034483,13.6295996 25.1034483,14.40625 L25.1034483,25.1875 L2.89655172,25.1875 L2.89655172,14.40625 C2.89655172,13.6295996 2.24813653,13 1.44827586,13 C0.64841519,13 0,13.6295996 0,14.40625 L0,25.65625 C0,26.9506674 1.08069198,28 2.4137931,28 L25.5862069,28 C26.919308,28 28,26.9506674 28,25.65625 L28,14.40625 C28,13.6295996 27.3515848,13 26.5517241,13 L26.5517241,13 Z",
						id: "Path"
					})]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconDownload);
export { ForwardRef as ReactComponent };
